module.exports = __webpack_public_path__ + "static/media/01_profile_picture.ee168ce3.png";